// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__ZRSc1","text":"style_text__YgOOW","hidden":"style_hidden__a1Bd6","textColor":"style_textColor__WnZoQ"};